import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Table from "react-bootstrap/Table";
import { TransactionHistoryFilter } from "../../holiday-pension-filters/TransactionHistoryFilter";
import Loader from "components/Loader";
import { formatDate } from "common/FunctionUtils";
import { Pagination } from "react-bootstrap";

export const PayoutHistory = ({ tabValue }) => {
  const { t } = useTranslation();
  const pageNumber = 10;
  const [totalHistory, settotalHistory] = useState();
  const [activePagination, setactivePagination] = useState(1);
  const [loading, setLoading] = useState(false);
  const [transHistoryData, setTransHisoryData] = useState([]);
  const [tFilterDate, setTFilterDate] = useState({
    from: "",
    to: "",
  });

  // Pagination Start
  let items = [];
  let paginationNumber = totalHistory / pageNumber;
  for (let number = 1; number <= Math.round(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  const getTransactionHistory = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/salary/holiday-payout-recived?PageSize=${pageNumber}&PageNumber=${activePagination}`
      );
      if (res?.status === 200) {
        setLoading(false);
        setTransHisoryData(res?.data?.response);
        settotalHistory(res.data.totalCount);
      }
    } catch (err) {
      setLoading(false);
      toast.error(t(err?.response?.data?.message));
    }
  }, [activePagination, pageNumber]);

  useEffect(() => {
    if (!tFilterDate?.from && !tFilterDate?.to) getTransactionHistory();
  }, [tFilterDate, pageNumber]);

  useEffect(() => {
    getTransactionHistory();
  }, [pageNumber, activePagination]);

  useEffect(() => {
    if (tabValue === "history") {
      setactivePagination(1);
    }
  }, [tabValue]);

  const filterTransactionData = async () => {
    setLoading(true);
    try {
      const dateStringFrom = new Date(tFilterDate?.from)
        .toISOString()
        .split("T")[0];
      const dateStringTo = new Date(tFilterDate?.to)
        .toISOString()
        .split("T")[0];

      const URL = `/salary/holiday-payout-recived?fromDate=${dateStringFrom}&toDate=${dateStringTo}`;
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        setTransHisoryData(result?.data?.response);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (tFilterDate?.from && tFilterDate?.to) {
      filterTransactionData();
    }
  }, [tFilterDate?.from, tFilterDate?.to]);
  const language = localStorage.getItem("i18nextLng");

  return (
    <>
      {loading && <Loader />}

      <div className="page-content salries">
        <div className="pay-checks">
          <h4 className="accident_ins font-weight-bold">
            {t("Your holiday saving payout")}
          </h4>
          <p>
            <span>
              {t("Here is the list of your holiday saving payout history.")}
            </span>
          </p>
          <TransactionHistoryFilter
            tFilterDate={tFilterDate}
            setTFilterDate={setTFilterDate}
            t={t}
          />
        </div>
      </div>

      <div className="trans-history-wrap">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Id")}</th>
              <th className="invoice_tabeletext">
                {t("Total amount requested")}
              </th>
              <th className="invoice_tabeletext">{t("Administrator Fee")}</th>
              <th className="invoice_tabeletext">{t("Amount")}</th>
              <th className="invoice_tabeletext">{t("Tax Amount")}</th>
              <th className="invoice_tabeletext">{t("To Pay Amount")}</th>
              <th className="invoice_tabeletext">{t("Status")}</th>
              <th className="invoice_tabeletext">{t("Payout Date")}</th>
            </tr>
          </thead>
          <tbody>
            {transHistoryData.length ? (
              transHistoryData?.map((tranData, index) => {
                // const serialNumber =
                //   (activePagination - 1) * pageNumber + index + 1;
                return (
                  <tr key={index}>
                    <td>{tranData?.id}</td>
                    <td>{tranData?.totalAmountRequested}</td>
                    <td>{tranData?.administratorFee || 0}</td>
                    <td>{tranData?.amount || 0}</td>
                    <td>{tranData?.taxAmount || 0}</td>
                    <td>{tranData?.toPayAmount || 0}</td>
                    <td>{tranData?.status === 1 ? t("Unpaid") : t("Paid")}</td>
                    <td>
                      {tranData?.status === 2 &&
                        formatDate(
                          tranData?.paidDate || 0,
                          false,
                          language
                        )}{" "}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8">
                  <h6>{t("No data found")}</h6>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      </div>
    </>
  );
};
